export default {
    systemCredentials: 'system/credentials',
    setCredentials: 'system/setCredentials'
}